import { Box } from '@chakra-ui/react';
import React from 'react';
import ResourceItemCard from './ResourceItemCard';
import { useUserActivity } from '../../../../hooks/V2/useUserActivity';

const ResourceBlockItems = ({ blockItems }: any) => {
	const { data: activityData, isLoading } = useUserActivity();

	return (
		<Box display={'flex'} flexWrap="wrap" gap="16px" pb="100px">
			{blockItems
				? // @ts-ignore
				  blockItems?.map(item => {
						const resource = item?.resource;
						console.log('resource:----', resource);
						const resourceMeta = {
							_id: resource?._id,
							label: resource?.label,
						};
						return <ResourceItemCard resource={resourceMeta} resourceProgress={activityData?.find(data => data?.entity === resource?._id)} />;
				  })
				: null}
		</Box>
	);
};

export default ResourceBlockItems;
